import { FormikField } from '@ahmdigital/ui';
import React from 'react';

import constants from '../../../../../../ahm-constants';

type StateFieldProps = {
  label?: string;
};

const StateField = ({ label = 'I live in' }: StateFieldProps) => (
  <FormikField
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ inputVariant: string[]; label: string; name: string; options: any; size: string; type: string; }' is not assignable to type 'IntrinsicAttributes & FormikFieldProps'.
    inputVariant={['button', 'fullWidth']}
    label={label}
    name="state"
    options={constants.STATE_OPTIONS}
    size="auto"
    type="dropdown"
  />
);

export default StateField;
